module.exports = __webpack_public_path__ + "static/media/checkprepared.b78a26de.png";